export default __webpack_public_path__ + "img/9a6ccd5ced597ef7c9f7841f404f63f5.png";